
import './_non-academic.scss'
import { CardBody } from "react-bootstrap/Card";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import PreloaderTwo from "../../../preloader/PreloaderTwo";
import React, { Component } from "react";
import { Row, Col, Nav, Card, Image, Tab, Form, Button, Container } from 'react-bootstrap'


const GET_FEE_DETAILS = gql`
 query($student_mobile: String) {
    getStudentFeeDetails(student_mobile: $student_mobile) {
        total_fees{
            fee_type
            total_amount
            pending_amount
          }
          paid_fees{
            fee_type
            paid_amount
            paid_date
          }
          due_fees{
            fee_type
            due_date
            due_amount
          }
        }
    }
`;


class NAFeeDetails extends Component {

    render() {

        const feeDetails = this.props.feeDetails;
        const loading1 = feeDetails.loading;
        const error1 = feeDetails.error;


        if (loading1) return <PreloaderTwo />;
        if (error1 !== undefined) {
            alert("Server Error. " + error1.message);
            return null;
        }


        let totalfee = [];
        let paidfee = [];
        let pendingfee = [];

        if (feeDetails.getStudentFeeDetails.length > 0) {
            totalfee = feeDetails.getStudentFeeDetails[0].total_fees;
            paidfee = feeDetails.getStudentFeeDetails[0].paid_fees;
            pendingfee = feeDetails.getStudentFeeDetails[0].due_fees;

        }

        return (
            <div className="feeDetails mt-3">
                <Container fluid >
                    <Row>
                        <Col>
                            <h5>Total Fee</h5>
                        </Col>
                    </Row>
                    {
                        totalfee.length > 0 ? (
                            totalfee.map((item) => {
                                return (
                                    <Card className='mt-2'>
                                        <Row>
                                            <Col className="text-center mt-1 font-color font-size">Fee Type</Col>
                                            <Col className="text-center mt-1 font-color">Pending Amount</Col>
                                            <Col className="text-center mt-1 font-color">Total Amount</Col>
                                        </Row>
                                        <Row>
                                            <Col className="text-center mt-1 ">{item.fee_type}</Col>
                                            <Col className="text-center mt-1 ">{item.pending_amount}</Col>
                                            <Col className="text-center mt-1 ">{item.total_amount}</Col>
                                        </Row>
                                    </Card>
                                )
                            })
                        ) : (
                            <h6 className='text-center'>No data found</h6>
                        )
                    }

                    <Row>
                        <Col>
                            <h5 className='mt-2'>Paid Fee</h5>
                        </Col>
                    </Row>

                    {
                        paidfee.length > 0 ? (
                            paidfee.map((item) => {
                                return (
                                    <Card className='mt-2'>
                                        <Row>
                                            <Col className="text-center mt-1 font-color font-size">Fee Type</Col>
                                            <Col className="text-center mt-1 font-color">Paid Amount</Col>
                                            <Col className="text-center mt-1 font-color">Paid Date</Col>
                                        </Row>
                                        <Row>
                                            <Col className="text-center mt-1 ">{item.fee_type}</Col>
                                            <Col className="text-center mt-1 ">{item.paid_amount}</Col>
                                            <Col className="text-center mt-1 ">{item.paid_date}</Col>
                                        </Row>
                                    </Card>
                                )
                            })
                        ) : (
                            <h6 className='text-center'>No paid fee</h6>
                        )
                    }
                    <Row>
                        <Col>
                            <h5 className='mt-2'>Due Fee</h5>
                        </Col>
                    </Row>
                    {
                        pendingfee.length > 0 ? (
                            pendingfee.map((item) => {
                                return (
                                    <Card className='mt-2'>
                                        <Row>
                                            <Col className="text-center mt-1 font-color font-size">Fee Type</Col>
                                            <Col className="text-center mt-1 font-color">Due Amount</Col>
                                            <Col className="text-center mt-1 font-color">Due Date</Col>
                                        </Row>
                                        <Row>
                                            <Col className="text-center mt-1 ">{item.fee_type}</Col>
                                            <Col className="text-center mt-1 ">{item.due_amount}</Col>
                                            <Col className="text-center mt-1 ">{item.due_date}</Col>
                                        </Row>
                                    </Card>
                                )
                            })
                        ) : (
                            <h6 className='text-center'>No pending fee</h6>
                        )
                    }
                </Container>
            </div>
        );
    }
}


export default withRouter(
    compose(
        graphql(
            GET_FEE_DETAILS,
            {
                options: props => ({
                    variables: {
                        student_mobile: props.stateData.studentData.contact_no.toString()
                    },
                    fetchPolicy: 'network-only'
                }),
                name: "feeDetails"
            }
        )
    )(NAFeeDetails)
);

